export default __webpack_public_path__ + "static/media/REACTIF ET PRODUIT CHIMIQUE.eefb07a5.jpg";